<p>update-asset-type-classification works!</p>
